/*==========================================================
HTML CLASSES SCRIPT
==========================================================*/
var topNavAdjust = false;

function checkTopNavMobile() {
    if (topNavAdjust) {
        topNavReset();
    }

    if (Modernizr.mq('only screen and (max-width: 991px)') && (Modernizr.touch) || Modernizr.mq('only all and (max-width: 991px)')) {
        topNavMobile();
    }
}

function topNavMobile() {
    if (!topNavAdjust) {
        if ($('#browseAloudContainer').length) {
            $('#browseAloudContainer').detach().appendTo('#nav').wrap('<li />');
        }

        var top = $('#topNav');

        if ($('#uber').is('.homepage') && top.length > 0) {
            top.find('ul>li').clone().appendTo('#nav').find('>a').addClass('mainNavItem topNavItem');
        }

        topNavAdjust = true;
    }
}

function topNavReset() {
    if (topNavAdjust) {
        topNavAdjust = false;

        var top = $('#nav .topNavItem');

        if ($('#browseAloudContainer').length) {
            $('#browseAloudContainer').unwrap('li').detach().insertAfter('#topNav');
        }

        if ($('#uber').is('.homepage') && top.length > 0) {
            top.removeClass('mainNavItem topNavItem').closest('li').remove();
        }
    }
}

$(window).load(function () {
    checkTopNavMobile();
});

//debounce resize instead of standard resize
$(window).debounceResize(function () {
    checkTopNavMobile();
});

$(function () {
    checkTopNavMobile();
});